import { Module } from "vuex";
import { initialState, IMdhState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const mdh: Module<IMdhState, any> = {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions,
};

export { mdh };
